var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import Box from "../Grid/Box";
const tags = {
    largest: "h1",
    large: "h2",
    default: "h3",
    small: "h4",
    smallest: "h5",
    section: "h3",
};
/** @type {import('theme-ui').ThemeUIStyleObject} */
const nowrapStyle = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
};
/** @typedef {import('./titleVariants').TitleVariant} TitleVariant */
/**
 * @param {object} props
 * @param {TitleVariant} [props.variant]
 * @param {React.ElementType} [props.as]
 * @param {boolean} [props.nowrap]
 * @param {import('theme-ui').ThemeUIStyleObject} [props.sx] SX props to apply to the text.
 * @param {React.ReactNode} props.children
 */
export default function Title(_a) {
    var { variant = "default", as = tags[variant] || tags.default, nowrap = false, children, sx = {} } = _a, rest = __rest(_a, ["variant", "as", "nowrap", "children", "sx"]);
    return (_jsx(Box, Object.assign({ as: as, sx: Object.assign(Object.assign({ margin: 0, padding: 0, variant: `title.${variant}` }, (nowrap && nowrapStyle)), sx) }, rest, { children: children })));
}
//# sourceMappingURL=Title.js.map